
import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditAdminUser from "@/components/EditAdminUser.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { AdminUser } from "types/adminUser"
import { DataTableHeader } from "vuetify/types"
import { AxiosError } from "axios"

@Component({
  components: {
    EditAdminUser,
    TableItemIsEnabled,
  },
})
export default class AdminUsers extends Vue {
  private loading = true
  private dialog = false
  private name = ""
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: 10,
    page: 1,
  }
  private adminUsers: AdminUser["data"][] = []
  @Prop()
  private role!: string
  @Prop()
  private roleName!: string

  get headers(): DataTableHeader[] {
    if (this.role === "writer") {
      return [
        { text: "ID", value: "id" },
        { text: "名称", value: "name" },
        { text: "Twitter", value: "twitterUrl" },
        { text: "YouTube", value: "youtubeUrl" },
        { text: "Instagram", value: "instagramUrl" },
        { text: "その他のURL", value: "linkUrl" },
        { text: "操作", value: "action", sortable: false },
      ]
    }
    return [
      { text: "ID", value: "id" },
      { text: "名称", value: "name" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  private getAdminUsers() {
    const p = this.pagination
    api
      .getAdminUsers(
        this.role,
        this.name,
        p.page,
        p.itemsPerPage,
        p.sortBy[0],
        p.sortDesc[0]
      )
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.adminUsers = res.data.adminUsers
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private searchAdminUsers() {
    this.resetPagination()
    this.getAdminUsers()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      this.getAdminUsers()
      this.loading = false
    }, 500)
  }

  private existThumbnail(adminUser: AdminUser["data"]): boolean {
    return adminUser.thumbnail.filename !== "" && adminUser.thumbnail.url !== ""
  }

  private createAdminUser() {
    if (this.pagination.page > 1) {
      this.pagination.page = 1 // Watchされていることに注意
    } else {
      this.getAdminUsers()
    }
    this.$toasted.success("アカウントを新規作成しました")
  }

  private updateAdminUser(adminUser: AdminUser["data"], page: number) {
    this.getAdminUsersByPage(page)

    // 自分自身を更新したら、ログイン情報も併せて更新
    if (this.$store.state.adminUser.id === adminUser.id) {
      this.$store.dispatch("adminUser/updateAdminUser", adminUser)
    }
    this.$toasted.success("アカウントを更新しました")
  }

  private deleteAdminUser(page: number) {
    this.getAdminUsersByPage(page)
    this.$toasted.success("アカウントを削除しました")
  }

  private getAdminUsersByPage(page: number) {
    api
      .getAdminUsers(
        this.role,
        this.name,
        page,
        10,
        this.pagination.sortBy[0],
        this.pagination.sortDesc[0]
      )
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.adminUsers = res.data.adminUsers
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private open(id?: number) {
    if (id === 0 || id) {
      const refs = this.$refs[id] as InstanceType<typeof EditAdminUser>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<
        typeof EditAdminUser
      >
      newDialog.open()
    }
  }

  private close() {
    this.dialog = false
  }

  private resetPaginationAndSearch() {
    this.name = ""
    this.onChangePage()
  }
}
